import {createAsyncAction, createAction} from "typesafe-actions"

// Models
import {DoctorStatsStateType, DoctorStatsType} from "../../models"
import {RecordsPeriod} from "../../utils/dateRange"

export const fetchStatsAsync = createAsyncAction(
    "@@doctor-stats/FETCH",
    "@@doctor-stats/FETCH_SUCCESS",
    "@@doctor-stats/FETCH_FAILURE",
)<undefined, DoctorStatsType, unknown>();

export const fetchInProgressRecordAsync = createAsyncAction(
    "@@doctor-stats/FETCH_IN_PROGRESS_RECORD",
    "@@doctor-stats/FETCH_IN_PROGRESS_RECORD_SUCCESS",
    "@@doctor-stats/FETCH_IN_PROGRESS_RECORD_FAILURE",
)<undefined, DoctorStatsStateType["inProgressRecord"], unknown>();

export const fetchAvailableRecordsAsync = createAsyncAction(
    "@@doctor-stats/FETCH_AVAILABLE_RECORDS",
    "@@doctor-stats/FETCH_AVAILABLE_RECORDS_SUCCESS",
    "@@doctor-stats/FETCH_AVAILABLE_RECORDS_FAILURE",
)<undefined, { records: DoctorStatsStateType["availableRecords"], total: DoctorStatsStateType["availableRecordsTotal"] }, unknown>();

export const setAvailableRecordsPage = createAction("@@doctor-stats/SET_AVAILABLE_RECORDS_PAGE")<number>()

export const setAvailableRecordSize = createAction("@@doctor-stats/SET_AVAILABLE_RECORDS_SIZE")<string>()

export const setAvailableRecordsPeriod = createAction("@@doctor-stats/SET_AVAILABLE_RECORDS_PERIOD")<RecordsPeriod>()